import React, { memo, useEffect } from 'react';
import Select from 'react-select';

const StaticDropdown = memo(function StaticDropdown({ onChange, value, options, clear, ...props }) {
  useEffect(function() {
    if (clear) {
      onChange(null);
    }
  }, [clear, onChange]);

  return (
    <div style={{ marginBottom: '2px' }}>
      <Select
        options={options || []}
        onChange={onChange}
        placeholder="Select"
        value={
          value
            ? options.filter(function(item) {
                return item.code === value.code;
              })[0] || null
            : null
        }
        getOptionLabel={function(e) { return e.label; }}
        getOptionValue={function(e) { return e.code; }}
        isClearable
        {...props}
        styles={{
          menu: function(base) { return { ...base, marginTop: 0 }; },
          control: function(base) { return { ...base, minHeight: '32px' }; },
        }}
      />
    </div>
  );
});

export default StaticDropdown;
